import { createReducer, createActions } from 'reduxsauce'
import Immutable from 'seamless-immutable'

// Redux type and action creators
const { Types, Creators } = createActions({
  uploadToggled: [],
  uploadClosed: [],
  reset: []
})

export const UploadTypes = Types
export default Creators

// Initial state
export const INITIAL_STATE = Immutable({
  open: false
})

// Redux reducers
export const uploadToggled = state => {
  const { open } = state

  return state.merge({ open: !open })
}

export const uploadClosed = state => {
  return state.merge({ open: false })
}

export const uploadReset = state => {
  return INITIAL_STATE
}

// Assign types to reducers
export const reducer = createReducer(INITIAL_STATE, {
  [Types.UPLOAD_TOGGLED]: uploadToggled,
  [Types.UPLOAD_CLOSED]: uploadClosed,
  [Types.RESET]: uploadReset
})



// WEBPACK FOOTER //
// ./src/redux/uploadRedux.js